import React, { FC } from 'react';
import { Label } from '../TypographyNew';
import { TrevorIcon } from '../TrevorIcon';
import {
  TabHeaderItem,
  TabsContainer,
  TabsContent,
  TabsHeader,
} from './Tabs.styles';
import { TabsProps } from './Tabs.types';

export const Tabs: FC<TabsProps> = ({
  activeTab,
  tabs,
  contents,
  onChange,
}) => {
  return (
    <TabsContainer>
      <TabsHeader>
        {tabs.map(({ label, iconName }, index) => (
          <TabHeaderItem
            key={label}
            active={index === activeTab}
            onClick={() => onChange(index)}
          >
            {iconName && <TrevorIcon name={iconName} />}
            <Label variant={2}>{label}</Label>
          </TabHeaderItem>
        ))}
      </TabsHeader>
      <TabsContent>{contents[activeTab]}</TabsContent>
    </TabsContainer>
  );
};
